import { PropertyMapper } from '../../decorators';

export class InvoiceStatus {
    @PropertyMapper()
    public id: number;

    @PropertyMapper()
    public name: string;
}
